Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles(_ref) {
  var isCentred = _ref.isCentred;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing;
  var container = {
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 'auto',
    gap: spacing.xs
  };
  if (isCentred || bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal, bp.mobile_m])) {
    container.flexDirection = 'column';
    container.alignItems = 'stretch';
    container.gap = spacing.normal;
    container.flexWrap = 'nowrap';
  }
  if (bp.mobile_l) {
    container.gap = (0, _styles.getREM)(0.375);
  }
  var styles = _reactNative.StyleSheet.create({
    container: container
  });
  return {
    styles: styles
  };
};